import * as React from "react";

export const HiddenLabels = ({cart}) => <>
    <span hidden xd-qa-type="label" xd-qa-name="Cart ID">{cart.cartId}</span>
    {cart.items?.map?.((item, index) => (
        <span key={index} hidden xd-qa-type="label" xd-qa-name={`Order ID ${index + 1}`}>{item.itemId}</span>
    ))}
</>;
